import { useCallback } from 'react';
import { useProductContext } from '..';
import { useSessionUserInput } from '../../..';
export const ActiveProductProvider = ({
  children
}) => {
  const {
    getActiveProduct
  } = useProductContext();
  const {
    showSearchAIDialog,
    toggleShowSearchAIDialog
  } = useSessionUserInput();
  const onCloseAIDialog = useCallback(() => {
    toggleShowSearchAIDialog(false);
  }, [toggleShowSearchAIDialog]);
  return children({
    activeProduct: getActiveProduct(),
    showSearchAIDialog,
    onCloseAIDialog
  });
};